import * as React from 'react';

const PrescriptionMarkChecked = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="29" height="28" viewBox="0 0 29 28" fill="none">
        <rect x="1" y="0.5" width="27" height="27" rx="13.5" fill="#FF8200" />
        <rect x="1" y="0.5" width="27" height="27" rx="13.5" stroke="#FF8200" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M10.7954 17.485L10.7952 17.4853L12.4917 19.1818L12.4919 19.1816L12.4921 19.1817L14.1886 17.4852L14.1885 17.485L20.977 10.6965L19.2804 9L12.4919 15.7885L9.69653 12.9931L8 14.6896L10.7954 17.485Z" fill="white" />
    </svg>
);

export default PrescriptionMarkChecked;